import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Form as TaroForm, View, } from "../_core/components";
import { FormItem } from "./FormItem";
import { FormDivider } from "./FormDivider";
import { FormContext } from "./FormContext";
import { useConfig } from "../_util/use-config";
export function Form(_a) {
    var children = _a.children, title = _a.title, labelWidth = _a.labelWidth, className = _a.className, style = _a.style, props = __rest(_a, ["children", "title", "labelWidth", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(TaroForm, __assign({}, props),
        React.createElement(View, { className: classNames(classPrefix + "-form", className), style: style },
            typeof title !== "undefined" && (React.createElement(View, { className: classPrefix + "-form__title" }, title)),
            React.createElement(View, { className: classNames(classPrefix + "-form__wrap") },
                React.createElement(FormContext.Provider, { value: { labelWidth: labelWidth } }, children)))));
}
function FormTitle(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-form__title", className) }, props)));
}
Form.Title = FormTitle;
Form.Item = FormItem;
Form.Divider = FormDivider;
//# sourceMappingURL=Form.js.map